__turbopack_context__.v({
  "container": "styles-module__z4myoa__container",
  "container-repop": "styles-module__z4myoa__container-repop",
  "ctaButtonWrapper": "styles-module__z4myoa__ctaButtonWrapper",
  "description": "styles-module__z4myoa__description",
  "iconText": "styles-module__z4myoa__iconText",
  "receiptsWrapper": "styles-module__z4myoa__receiptsWrapper",
  "title": "styles-module__z4myoa__title",
});
